/**
 * Creates a object for every .common-form-File DOM element.
 */
common.View.create('crud::form.inputs.Basicfile', {

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad()
	{
		this.initOnFileChosen();
	},

	initOnFileChosen()
	{
		$('input', this.element).change((event) =>
		{
			let length = event.currentTarget.files.length;

			$(event.currentTarget).parents('.fileUpload')
				//.toggleClass('file-chosen', length)
				.find('.value')
				.hide()
				.end()
				.find('span.selected')
				.show()
				.find('.amount')
				.html(length)
				.end()
				.end();
		});
	},

});